import styled from 'styled-components';
import { palette } from 'theme/MainTheme';

const DeviceCardActionTuple = styled.div`
	display: flex;
	align-items: center;
	font-size: 12px;

	.delete {
		.icon {
			color: #ffffff !important;
		}
	}
	.icon {
		font-size: 20px;
		color: ${palette('text', 4)};

		&:hover {
			color: ${palette('secondary', 0)};
		}
	}
	.iconCenter {
		justify-content: center;
	}

	.iconMargin {
		margin-right: 10px;
		display: flex;
		align-items: center;
	}
`;

const DropdownSpaceWrapper = styled.p`
	display: flex;
	align-items: center;
	gap: 10px;
`;
export { DeviceCardActionTuple, DropdownSpaceWrapper as SpaceWrapper };
